/*
 * Created by Volodymyr Mak. on 6/5/2020.
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'curr-progress-bar-gradient',
  templateUrl: './progress-bar-gradient.component.html',
  styleUrls: ['./progress-bar-gradient.component.scss']
})
export class ProgressBarGradientComponent {
  @Input() benchmark: string;
  @Input() averageGrade: string;
  @Input() progress: number;
  @Input() readyPerformance: number;

  private gradeOrder = ['A*', 'A', 'B', 'C', 'D', 'E', 'U (NP)', 'U (BS)', 'U (Fail)'];
  private gcseGradeOrder = ['9', '8', '7', '6', '5', '4', '3', '2', '1'];

  getProgress(): number {
    if (this.readyPerformance) return this.readyPerformance;
    if (!this.progress) return 0;

    let benchmarkIndex: number;
    let gradeIndex: number;

    if (!isNaN(Number(this.averageGrade))) {
      benchmarkIndex = this.gcseGradeOrder.indexOf(this.benchmark);
      gradeIndex = this.gcseGradeOrder.indexOf(this.averageGrade);
    } else {
      benchmarkIndex = this.gradeOrder.indexOf(this.benchmark);
      gradeIndex = this.gradeOrder.indexOf(this.averageGrade);
    }

    if (gradeIndex === -1 || benchmarkIndex === -1) return 0;

    const step = 12;
    const difference = gradeIndex - benchmarkIndex;

    if (difference <= 0) return 100;

    return Math.max(100 - difference * step, 12);
  }

  getPerformanceClass(): string {
    const progress = this.getProgress();

    if (progress === 100) return 'green';
    if (progress >= 80) return 'yellow';
    return 'red';
  }
}
